import { render, staticRenderFns } from "./HaulageLocation.vue?vue&type=template&id=739f16b4&scoped=true&"
import script from "./HaulageLocation.vue?vue&type=script&lang=js&"
export * from "./HaulageLocation.vue?vue&type=script&lang=js&"
import style0 from "./HaulageLocation.vue?vue&type=style&index=0&id=739f16b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739f16b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('739f16b4')) {
      api.createRecord('739f16b4', component.options)
    } else {
      api.reload('739f16b4', component.options)
    }
    module.hot.accept("./HaulageLocation.vue?vue&type=template&id=739f16b4&scoped=true&", function () {
      api.rerender('739f16b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/booking/HaulageLocation.vue"
export default component.exports